
export enum ResponseStatus {
  STATUS_200_OK                      = 200,
  STATUS_401_UNAUTHORIZED            = 401,
  STATUS_404_NOT_FOUND               = 404,
  STATUS_407_AUTHENTICATION_REQUIRED = 407,
  STATUS_412_PRECONDITION_FAILED     = 412,
}
